export const addFormFieldStyles = {
	add: {
		pointerEvents: 'auto',
		color: 'text.secondary',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		margin: 'auto',
		padding: 'auto',

		'&:hover': {
			color: 'text.primary',
			backgroundColor: 'var(--mui-palette-action-hover)'
		}
	},

	icon: {
		width: '15px',
		height: '15px'
	}
};
